import sidebar from '@/config/sidebars/adminHubspot'
import createVueApp from '@/common/createApp'

Styxie.Initializers.AdminHubspotDeals = {
  index: async(props) => {
    const { default: DealsIndex } = await import('@/vue_widgets/admin/hubspot/deals/index.vue')
    createVueApp(DealsIndex, { props, sidebar })
  },
  show: async(props) => {
    const { default: DealsShow } = await import('@/vue_widgets/admin/hubspot/deals/show.vue')
    createVueApp(DealsShow, { props, sidebar })
  }
}
